import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { CancelRequest, cancelConfirmation } from '@utils/backend-api/cancelSubscription';

export default function useCancelSubscription() {
  const { mutate, isLoading, isError } = useMutation(
    (values: CancelRequest) => cancelConfirmation(values),
    {
      onSuccess: (data) => {
        if (data.success) {
          window.location.href = data.redirectUri;
        }
      },
      onError: () => {
        toast.error('Your account cancellation failed, please try again later');
      },
    }
  );
  return { mutate, isLoading, isError };
}
